import { refs } from './js/refs';
import { addTask, deleteTasks, initTasks } from './js/tasks';
import { changeTheme, initTheme } from './js/theme-switcher';

initTasks();
initTheme();

refs.form.addEventListener('submit', clickAdd);

function clickAdd(event) {
  event.preventDefault();
  const title = event.target.elements.taskName.value.trim();
  const description = event.target.elements.taskDescription.value.trim();

  if (!title || !description) {
    alert('Input can not be empty');
    return;
  }

  const task = { title, description };

  addTask(task);

  refs.form.reset();
}

refs.list.addEventListener('click', event => {
  if (event.target.nodeName !== 'BUTTON') {
    return;
  }
  const value = event.target.nextElementSibling.textContent;

  deleteTasks(value);
});

refs.changeThemeBtn.addEventListener('click', changeTheme);

/*
  Створи список справ.
  На сторінці є два інпути які має вводиться назва і текст задачі.
  Після натискання на кнопку "Add" завдання додається до списку #task-list.

  У кожної картки має бути кнопка "Delete", щоб можна було
  прибрати завдання зі списку.
  Список із завданнями має бути доступним після перезавантаження сторінки.

  Розмітка картки задачі
  <li class="task-list-item">
      <button class="task-list-item-btn">Delete</button>
      <h3>Заголовок</h3>
      <p>Текст</p>
  </li>
*/
